import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Notification from 'app/components/Notification';
import Button from 'app/components/Button';
import Icon from 'app/components/Icon';
import { Colors } from 'app/utils/colors';

export default function B2BSubscriptionNotification({ checkoutUrl }) {
  const intl = useIntl();

  return (
    <>
      <Notification
        header={intl.formatMessage({
          id: 'controlpanel.payment_methods.subscription.notification.b2b.title'
        })}
        content={intl.formatMessage({
          id: 'controlpanel.payment_methods.subscription.notification.b2b.subtitle'
        })}
        variant="info"
        button={null}
      />
      <div className="bb-payment-methods-bigbuy-page__content__subscriptions__activate">
        <Button
          onClick={() => {
            window.location.href = checkoutUrl;
          }}
          text={intl.formatMessage({
            id: 'controlpanel.wholesaler_pack.button.change'
          })}
          size="big"
          type="primary"
          icon={
            <Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />
          }
        />
      </div>
    </>
  );
}

B2BSubscriptionNotification.propTypes = {
  checkoutUrl: PropTypes.string.isRequired
};
